import { usersAPI } from "../api/api";
import { updateObjectInArray } from '../utils/object-helpers'

const FOLLOW = 'users/FOLLOW';
const UN_FOLLOW = 'users/UN_FOLLOW';
const SET_USERS = 'users/SET_USERS';
const SET_CURRENT_PAGE = 'users/SET_CURRENT_PAGE'
const SET_TOTAL_COUNT = 'users/SET_TOTAL_COUNT'
const TOGGLE_PRELOAD = 'users/TOGGLE_PRELOAD'
const TOGGLE_IS_FOLLOWING_PROGRESS = 'users/TOGGLE_IS_FOLLOWING_PROGRESS'


let initialState = {
  users: [],
  pageSize: 100,
  portionSize: 5,
  totalUsersCount: 0,
  currentPage: 1,
  isFetching: true,
  followingInProgress: []
}

const usersReducer = (state = initialState, action) => {

  switch (action.type) {
    case FOLLOW:
      return {
        ...state,
        users: updateObjectInArray(state.users, action.id, 'id', { followed: true }),
      }
    case UN_FOLLOW:
      return {
        ...state,
        users: updateObjectInArray(state.users, action.id, 'id', { followed: false }),
      }
    case SET_USERS:
      return {
        ...state,
        users: [...action.users]
      }
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.currentPage
      }
    case SET_TOTAL_COUNT:
      return {
        ...state,
        totalUsersCount: action.count
      }
    case TOGGLE_PRELOAD:
      return {
        ...state,
        isFetching: action.isFetching
      }
    case TOGGLE_IS_FOLLOWING_PROGRESS:
      return {
        ...state,
        followingInProgress: action.isFetching
          ? [...state.followingInProgress, action.userId]
          : state.followingInProgress.filter(id => id !== action.userId)
      }

    default:
      return state;
  }
}

export const follow = (userId) => ({ type: FOLLOW, id: userId })
export const unFollow = (userId) => ({ type: UN_FOLLOW, id: userId })
export const setUsers = (users) => ({ type: SET_USERS, users })
export const setCurrentPage = (currentPage) => ({ type: SET_CURRENT_PAGE, currentPage })
export const setTotalUsersCount = (count) => ({ type: SET_TOTAL_COUNT, count })

export const togglePreload = (isFetching) => ({ type: TOGGLE_PRELOAD, isFetching })
export const toggleInProgress = (isFetching, userId) => ({ type: TOGGLE_IS_FOLLOWING_PROGRESS, isFetching, userId })


export const getUsersThunk = (currentPage, pageSize) => async (dispatch) => {
  let response = await usersAPI.getUsers(currentPage, pageSize)

  dispatch(togglePreload(true));
  dispatch(setCurrentPage(currentPage))
  dispatch(togglePreload(false));
  dispatch(setUsers(response.items));
  dispatch(setTotalUsersCount(response.totalCount));
}

const followUnFollowFlow = async (dispatch, userId, apiMethod, actionCreator) => {
  dispatch(toggleInProgress(true, userId))
  await apiMethod(userId)
  dispatch(actionCreator(userId))
  dispatch(toggleInProgress(false, userId))
}

export const getFollow = (userId) => async (dispatch) => {
  followUnFollowFlow(dispatch, userId, usersAPI.follow.bind(usersAPI), follow)
}

export const getUnFollow = (userId) => async (dispatch) => {
  followUnFollowFlow(dispatch, userId, usersAPI.unFollow.bind(usersAPI), unFollow)
}

export default usersReducer;